import React from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';

// Since there's not a way of appending to I18nModel right now
// using this method. Will talk with yuzhong about support for this
const getData = i18n => i18n.p$data.value().resource.data;

const mergeI18n = (target, parentI18n) => {
  Object.assign(getData(target), getData(parentI18n));
};

/* This is to merge the parent and child i18n(App and Feature) */
export const withMergedI18n = (Component, childI18n) => {
  const HoC = props => (
    <I18nContext.Consumer>
      {(parentI18n = props.i18n) => {
        mergeI18n(childI18n, parentI18n);
        return (
          <I18nContext.Provider value={childI18n}>
            <Component {...props} i18n={childI18n} />
          </I18nContext.Provider>
        );
      }}
    </I18nContext.Consumer>
  );

  HoC.propTypes = {
    i18n: PropTypes.shape({}),
  };

  HoC.defaultProps = {
    i18n: undefined,
  };

  return HoC;
};
